import { DeviceListingFieldName, EquipmentListingFieldName } from '../components/devices.models';

export const meteringTableSortField: Record<string, EquipmentListingFieldName> = {
  deviceTypeName: DeviceListingFieldName.DeviceType,
  model: DeviceListingFieldName.Description,
  status: DeviceListingFieldName.Status,
  deviceStatusValue: DeviceListingFieldName.Health,
  lastHeard: DeviceListingFieldName.LastHeard,
  batteryStatus: DeviceListingFieldName.BatteryStatus,
  transmissionReadRateStatus: DeviceListingFieldName.TransmissionReadRateStatus,
  validTransmissionReadRateStatus: DeviceListingFieldName.ValidTransmissionReadRateStatus,
  commodity: DeviceListingFieldName.Commodity,
  meterNumber: DeviceListingFieldName.MeterNumber
};
